export enum DocumentActionType {
  SEND_A_COPY = 'send-a-copy',
  EDIT = 'edit',
  PRINT = 'print',
}
